import { gql } from '@apollo/client'

export const DECRYPT_TOKEN = gql`
  mutation decryptToken($token: String!) {
    decryptToken(token: $token) {
      id
      type_user
      name
      first_name
      last_name
      avatar
      role
      email
      phone
      address
      jurisdiction_id
      sub_jurisdiction_id
      provider_id
      is_coordinator
    }
  }
`

export const AUTH_USER = gql`
  mutation authUser($input: userLoginInput!) {
    authUser(input: $input) {
      token
    }
  }
`

export const EMPTY = gql`
  mutation _emptyMutation {
    _empty
  }
`

export const APP_CONFIG = gql`
  query AppConfig {
    getConfigSys {
      project_logo
      project_name
      project_mini_logo
      project_favicon
      votes_switch
    }
  }
`

export const CHANGE_VOTES_SWITCH = gql`
  mutation ChangeVotesSwitch($voteSwitch: Int!) {
    changeVotesSwitch(voteSwitch: $voteSwitch)
  }
`

/**
 * Get the status of the account deletion request
 * @param {String} payload - The payload containing the token
 * @returns {Object} - The status of the account deletion request
 * @property {Boolean} expired - Indicates if the token is expired
 * @property {String} message - The message associated with the request
 * @property {String} status - The status of the request
 * @property {String} userEmail - The email of the user associated with the request
 * @property {String} userName - The name of the user associated with the request
 * @property {String} userPhone - The phone number of the user associated with the request
 * @description This query is used to check the status of the account deletion request.
 * It takes a payload containing the token and returns the status of the request.
 * The response includes information such as whether the token is expired, the message associated with the request,
 * the status of the request, and the user's email, name, and phone number.
 * @example
 * const { data, loading, error } = useQuery(APP_ACCOUNT_DELETE_STATUS, {
 *   variables: { payload: 'your-token-here' },
 * });
 */
export const APP_ACCOUNT_DELETE_STATUS = gql`
  query appAccountDeleteStatus($payload: String!) {
    appAccountDeleteStatus(payload: $payload) {
      expired
      message
      status
      userEmail
      userName
      userPhone
    }
  }
`
/**
 * Confirm the account deletion request
 * @param {String} payload - The payload containing the token
 * @returns {Boolean} - Indicates if the account deletion was confirmed
 * @description This mutation is used to confirm the account deletion request.
 * It takes a payload containing the token and returns a boolean indicating
 * whether the account deletion was confirmed successfully.
 * @example
 * const [confirmDeletion] = useMutation(APP_ACCOUNT_DELETE_CONFIRMATION);
 * const handleConfirm = async () => {
 *   const { data } = await confirmDeletion({
 *     variables: { payload: 'your-token-here' },
 *   });
 *   console.log(data.appAccountDeleteConfirm); // true or false
 * };
 */
export const APP_ACCOUNT_DELETE_CONFIRMATION = gql`
  mutation appAccountDeleteConfirm($payload: String!) {
    appAccountDeleteConfirm(payload: $payload)
  }
`
